import React, {useState, useEffect} from "react";
import {useLocation} from "react-router-dom";
import AgeGate from "./components/AgeGate";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Cookie from "js-cookie";
import Routes from "./routes";
import {useSelector, useDispatch} from "react-redux";
import {get} from "lodash";
import ScrollToTop from "./components/ScrollToTop";
import CookieCompliance from "./components/CookieCompliance";
import "./css/styles.css";
import RenderMetaTags from "./components/SEO";

import {ThemeProvider} from "@material-ui/core/styles";
import {theme} from "./theme";

var pjson = require("../package.json");

console.log(`Version: ${pjson.version}`);

export default function App() {
  const dispatch = useDispatch();

  const location = useLocation();
  const isPrivacyPolicy =
    location.pathname === "/privacy-policy" ||
    location.pathname === "/terms-of-service";

  const isStaging =
    window.location.hostname.includes("localhost") ||
    window.location.hostname.includes("crescolabsdev");

  const over21cookie = Cookie.get("hs_over21") || false;
  const [ageVerified, setAgeVerified] = useState(over21cookie);

  const [loading, setLoading] = useState(true);

  const enableAnalytics = useSelector((state) =>
    get(state, "cookieCompliance.analytics", false)
  );

  const handleLoading = (value) => {
    if (value === "yas") {
      setTimeout(() => {
        setLoading(value);
      }, 200);
    } else {
      setLoading(value);
    }
  };

  const verifyAge = () => {
    setAgeVerified(true);
  };

  useEffect(() => {
    dispatch({
      type: "INITIALIZE_APP",
    });

    const s = document.createElement("link");
    s.rel = "stylesheet";
    s.href = "https://use.typekit.net/pgc1ovv.css";
    document.getElementsByTagName("head")[0].append(s);
  }, [dispatch]);

  useEffect(() => {
    if (isPrivacyPolicy) {
      setAgeVerified(isPrivacyPolicy);
    } else {
      setAgeVerified(over21cookie);
    }
  }, [location.pathname, isPrivacyPolicy, over21cookie]);

  useEffect(() => {
    if (enableAnalytics) {
      window.analytics.page();
    }
  }, [location.pathname, enableAnalytics]);

  useEffect(() => {
    handleLoading(true);
  }, [location.pathname]);

  return (
    <ThemeProvider theme={theme}>
      <ScrollToTop>
        <RenderMetaTags pathname={location.pathname} />
        {!ageVerified && <AgeGate verifyAge={verifyAge} />}
        <Header activePage={location.pathname} />
        <div className={"no-flick"}>
          <Routes
            loading={handleLoading}
            isStaging={isStaging}
            animation={loading}
          />
        </div>
        <Footer />
        <CookieCompliance />
      </ScrollToTop>
    </ThemeProvider>
  );
}
